<template>
  <div class="breadcrum wrap">
    <div class="login" v-show="!username"><el-link :underline="false" @click="goLogin()"><i class="el-icon-user-solid"></i><span>登录</span> </el-link></div>
<div class="listed" v-show="username">
    <span class="user">登录用户：{{username}}</span>
    
  <el-link :underline="false" @click="goUser()"><i class="el-icon-user-solid" ></i><span>个人中心</span> </el-link>
  <!-- <el-link :underline="false" href='http://www.rczxsamr.org.cn/rcms_console/toLogin'><i class="el-icon-s-tools" ></i><span>管理中心</span> </el-link> -->
  <el-link :underline="false" @click="quit()"><i class="el-icon-error"></i><span>退出</span> </el-link>
</div>
  </div>
</template>

<script>
export default {
    data(){
 return{
        username:"",  
    }
    },
   
    methods:{
        goLogin(){
            this.$router.push("/login");
        },
        goUser(){
            //  this.loading=true
             
               setTimeout(() => {
               this.$router.push("/user");    
            }, 1000); 
        },
        quit(){
            this.$message('用户已退出');
             sessionStorage.clear();
            setTimeout(() => {
               this.$router.push("/");   
              //  this.$router.go(0);
            }, 1000);
           
        }
    },
    created() {
      let names = sessionStorage.getItem("name");
    let name = JSON.parse(names);
    this.username=name
    //  // console.log(this.username);
    },
}

</script>

<style lang="less" scoped>

.login{
     text-align: right;
    font-size: 18px;
    margin-right: 79px;
    color: #0D61A0;
    // display: block;
    
     .el-link{
    font-size: 18px;
    line-height: 46px;
   margin-right: 20px;
   span{
    display:table;
    display:table-cell;
    vertical-align:middle;
     color: #0D61A0;
   }
    .el-icon-user-solid{
        font-size: 30px;
        display:table;
        display:table-cell;
        vertical-align:middle;
        padding-right: 10px;
         color: #0D61A0;
    }
    .el-icon-s-tools{
        font-size: 30px;
        display:table;
        display:table-cell;
        vertical-align:middle;
        padding-right: 10px;
         color: #0D61A0;
    }
  
   }


}
.breadcrum{
    height: 46px;
    background-color: #DBE2E8;
}
.listed{
    // display: none;
    text-align: right;
    font-size: 18px;
    margin-right: 79px;
    color: #0D61A0;
  .user{
    line-height: 46px;
    margin-right: 30px;
  }
   .el-link{
    font-size: 18px;
    line-height: 46px;
   margin-right: 20px;
   span{
    display:table;
    display:table-cell;
    vertical-align:middle;
     color: #0D61A0;
   }
    .el-icon-user-solid{
        font-size: 30px;
        display:table;
        display:table-cell;
        vertical-align:middle;
        padding-right: 10px;
         color: #0D61A0;
    }
     .el-icon-s-tools{
        font-size: 30px;
        display:table;
        display:table-cell;
        vertical-align:middle;
        padding-right: 10px;
         color: #0D61A0;
    }
    .el-icon-error{
        font-size: 30px;
        display:table;
        display:table-cell;
        vertical-align:middle;
        padding-right: 10px;
         color: #0D61A0;
    }
   }
}
@media  screen and(max-width:768px) {
  .login{
    margin-right: 14px;
  }
  .listed{
    margin-right: 0;
  }
}
.breadcrum{
  height: auto;
}

</style>